/* eslint-disable @typescript-eslint/no-explicit-any */
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CloseIcon from '@mui/icons-material/Close';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { Box, Button, IconButton, Stack, TextField, Typography } from '@mui/material';
import { IChecklistTemplateSection } from '../types';

interface EditableSectionNodeProps {
  section: IChecklistTemplateSection | any;
  onRenameSection: (sectionId: string, newTitle: string) => void;
  onRemoveSection: (sectionId: string) => void;
  onRenameItem: (sectionId: string, itemId: string, newName: string) => void;
  onAddItemToSection: (sectionId: string) => void;
  onRemoveItemFromSection: (sectionId: string, itemId: string) => void;
}

export const EditableSectionNode = ({
  section,
  onRenameSection,
  onRemoveSection,
  onRenameItem,
  onAddItemToSection,
  onRemoveItemFromSection
}: EditableSectionNodeProps) => {
  return (
    <Box
      sx={{
        mb: 3,
        p: 2,
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: '#f8fafc'
      }}>
      {/* INTESTAZIONE SEZIONE: INPUT PER CAMBIO NOME + RIMOZIONE SEZIONE */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
        <TextField
          size="small"
          variant="standard"
          placeholder="Nome Sezione..."
          value={section.title || ''}
          onChange={(e) => onRenameSection(section.id, e.target.value)}
          inputProps={{ style: { fontWeight: 700, color: '#334155', fontSize: '0.95rem' } }}
          sx={{ flex: 1 }}
        />
        <IconButton
          size="small"
          color="error"
          onClick={() => onRemoveSection(section.id)}
          title="Elimina Sezione">
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Stack>

      {/* ELENCO DEGLI ITEMS NESTED ALL'INTERNO DELLA SEZIONE */}
      <Stack spacing={1.5} sx={{ pl: 2, mb: 2 }}>
        {section.items?.map((item: any, itemIndex: number) => (
          <Stack key={item.id} direction="row" spacing={1.5} alignItems="center">
            <Typography variant="body2" sx={{ color: 'text.disabled', minWidth: '20px' }}>
              {itemIndex + 1}.
            </Typography>

            {/* INPUT PER CAMBIO NOME DEL SINGOLO ELEMENTO */}
            <TextField
              size="small"
              variant="outlined"
              fullWidth
              placeholder="Nome elemento..."
              value={item.name || ''}
              onChange={(e) => onRenameItem(section.id, item.id, e.target.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  bgcolor: '#ffffff',
                  fontSize: '0.85rem'
                }
              }}
            />

            <IconButton
              size="small"
              onClick={() => onRemoveItemFromSection(section.id, item.id)}
              sx={{ color: 'text.disabled', '&:hover': { color: 'error.main' } }}
              title="Elimina Elemento">
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        ))}

        {section.items?.length === 0 && (
          <Typography variant="caption" sx={{ color: 'text.disabled', fontStyle: 'italic', pl: 1 }}>
            Nessun elemento presente in questa sezione.
          </Typography>
        )}
      </Stack>

      {/* PULSANTE AGGIUNTA ITEM TARGETIZZATO PER QUESTA SEZIONE */}
      <Button
        size="small"
        variant="text"
        startIcon={<AddCircleOutlineIcon />}
        onClick={() => onAddItemToSection(section.id)}
        sx={{ textTransform: 'none', fontWeight: 600, fontSize: '0.8rem', ml: 1 }}>
        Aggiungi Elemento a questa sezione
      </Button>
    </Box>
  );
};
